// Formatação de CPF: 000.000.000-00
export const formatCPF = (value) => {
  if (!value) return '';
  const numbers = value.replace(/\D/g, '');
  if (numbers.length <= 11) {
    return numbers
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }
  return value;
};

// Validação de CPF
export const validateCPF = (cpf) => {
  if (!cpf) return true; // CPF vazio é válido (não obrigatório)
  
  const numbers = cpf.replace(/\D/g, '');
  
  if (numbers.length !== 11) return false;
  
  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(numbers)) return false;
  
  // Validação do primeiro dígito verificador
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(numbers[i]) * (10 - i);
  }
  let digit1 = (sum * 10) % 11;
  if (digit1 === 10) digit1 = 0;
  if (digit1 !== parseInt(numbers[9])) return false;
  
  // Validação do segundo dígito verificador
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(numbers[i]) * (11 - i);
  }
  let digit2 = (sum * 10) % 11;
  if (digit2 === 10) digit2 = 0;
  if (digit2 !== parseInt(numbers[10])) return false;
  
  return true;
};

// Formatação de CNPJ: 00.000.000/0000-00
export const formatCNPJ = (value) => {
  if (!value) return '';
  const numbers = value.replace(/\D/g, '');
  if (numbers.length <= 14) {
    return numbers
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
  }
  return value;
};

// Validação de CNPJ
export const validateCNPJ = (cnpj) => {
  if (!cnpj) return true; // CNPJ vazio é válido (não obrigatório)
  
  const numbers = cnpj.replace(/\D/g, '');
  
  if (numbers.length !== 14) return false;
  
  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{13}$/.test(numbers)) return false;
  
  // Validação do primeiro dígito verificador
  let size = numbers.length - 2;
  let nums = numbers.substring(0, size);
  const digits = numbers.substring(size);
  let sum = 0;
  let pos = size - 7;
  
  for (let i = size; i >= 1; i--) {
    sum += parseInt(nums.charAt(size - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  
  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(digits.charAt(0))) return false;
  
  // Validação do segundo dígito verificador
  size = size + 1;
  nums = numbers.substring(0, size);
  sum = 0;
  pos = size - 7;
  
  for (let i = size; i >= 1; i--) {
    sum += parseInt(nums.charAt(size - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  
  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(digits.charAt(1))) return false;
  
  return true;
};

// Formatar CPF ou CNPJ baseado no tamanho
export const formatCPFCNPJ = (value) => {
  if (!value) return '';
  const numbers = value.replace(/\D/g, '');
  if (numbers.length <= 11) {
    return formatCPF(value);
  }
  return formatCNPJ(value);
};

// Validar CPF ou CNPJ baseado no tamanho
export const validateCPFCNPJ = (value) => {
  if (!value) return true;
  const numbers = value.replace(/\D/g, '');
  if (numbers.length <= 11) {
    return validateCPF(value);
  }
  return validateCNPJ(value);
};

// Formatação de Telefone: (00) 00000-0000
export const formatPhone = (value) => {
  if (!value) return '';
  const numbers = value.replace(/\D/g, '');
  if (numbers.length <= 11) {
    return numbers
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1');
  }
  return value;
};

// Calcular taxa de cartão
export const calcularTaxa = (tipo, operadora, parcelas) => {
  if (tipo === 'pix' || tipo === 'especie') {
    return 0.0;
  }
  
  if (tipo === 'debito') {
    if (operadora === 'mastercard' || operadora === 'visa') {
      return 0.70;
    } else if (operadora === 'elo') {
      return 1.50;
    }
    return 0.70;
  }
  
  if (tipo === 'credito') {
    if (!parcelas || parcelas === 1) {
      if (operadora === 'mastercard' || operadora === 'visa') {
        return 2.78;
      } else if (operadora === 'elo' || operadora === 'amex') {
        return 3.58;
      }
      return 2.78;
    }
    
    const taxasMastercardVisa = {
      2: 3.80, 3: 4.39, 4: 4.98, 5: 5.57, 6: 6.16,
      7: 6.97, 8: 7.56, 9: 8.15, 10: 8.74, 11: 9.33, 12: 9.92
    };
    const taxasEloAmex = {
      2: 4.60, 3: 5.19, 4: 5.78, 5: 6.37, 6: 6.96,
      7: 7.77, 8: 8.36, 9: 8.95, 10: 9.54, 11: 10.13, 12: 10.72
    };
    
    if (operadora === 'mastercard' || operadora === 'visa') {
      return taxasMastercardVisa[parcelas] || 2.78;
    } else if (operadora === 'elo' || operadora === 'amex') {
      return taxasEloAmex[parcelas] || 3.58;
    }
    
    return taxasMastercardVisa[parcelas] || 2.78;
  }
  
  return 0.0;
};

// Calcular valor líquido
export const calcularValorLiquido = (valor, taxa) => {
  return valor * (1 - taxa / 100);
};

// Formatar data para exibição (corrige problema de timezone)
export const formatDateDisplay = (dateStr) => {
  if (!dateStr) return '';
  // Pega apenas a parte da data (YYYY-MM-DD) e cria o Date sem timezone
  const datePart = dateStr.split('T')[0];
  const [year, month, day] = datePart.split('-').map(Number);
  return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
};

// Formatar data para input (YYYY-MM-DD)
export const formatDateInput = (dateStr) => {
  if (!dateStr) return '';
  return dateStr.split('T')[0];
};

// Normalizar texto para pesquisa (remove acentos e converte para minúsculo)
export const normalizeText = (text) => {
  if (!text) return '';
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, ''); // Remove diacríticos (acentos)
};

// Verificar se texto contém termo de busca (ignora acentos)
export const searchMatch = (text, searchTerm) => {
  if (!text || !searchTerm) return false;
  return normalizeText(text).includes(normalizeText(searchTerm));
};

// Formatação de moeda brasileira: R$ 10.000,00
export const formatCurrency = (value, showSymbol = true) => {
  const num = Number(value || 0);
  const formatted = num.toLocaleString('pt-BR', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  });
  return showSymbol ? `R$ ${formatted}` : formatted;
};

// Formatação de moeda sem símbolo (apenas número)
export const formatNumber = (value) => {
  return Number(value || 0).toLocaleString('pt-BR', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  });
};
